import useDateRangeFilter from "../../portlibs/DateRangeFilterProvider";
import DatePicker from "../../gui/Calendar/DatePicker";
import { UpdateEvent } from "../../gui/GUIEvents";

export default function(){
    const {start,end,setStart,setEnd} = useDateRangeFilter()
    const onStart = (e:UpdateEvent<Date>) => {
        console.log("start",e.value)
        e.value && setStart(e.value)
    }
    const onEnd = (e:UpdateEvent<Date>) => e.value && setEnd(e.value)
    return <div className="dates flex gap-16">
        <DatePicker placeholder="Start" float={true} value={start} onUpdate={onStart}/>
        <DatePicker placeholder="End" float={true} value={end} onUpdate={onEnd}/>
    </div>
}